import React, {useEffect} from "react";
import PropTypes from "prop-types";
import useTileCollection from "../../../services/stores/TileCollectionStore";
import Tile from "../Tile/Tile";
import Footer from "../../components/Footer";
import {useLocation} from "react-router-dom";
import Helpers from "../../../services/Helpers";
import BatchingFoundationsPurchase from "./BatchingFoundationsPurchase";

export default function TileCollection(props) {
  const location = useLocation();
  const {pageTitle} = Helpers();
  const protectedPage = props.protectedBatchingFoundations;
  const memberReady = !props.waitingForMember && props.member && props.member.id != null;
  const eligible = props.authenticated && memberReady
    && (props.member.admin || (props.member.hasMP && !props.member.hasTrial));
  const {tileCollection, status, denied, error} = useTileCollection(
    props.token, props.id, !protectedPage || (eligible && !props.waitingForRoutes)
  );

  useEffect(() => {
    document.title = pageTitle(location.pathname);
  }, [location]);

  if (protectedPage) {
    if (!props.authenticated || (!props.waitingForMember && !eligible) || denied) {
      return <BatchingFoundationsPurchase />;
    }
    if (!memberReady || props.waitingForRoutes || status !== "success") {
      const message = memberReady && !props.waitingForRoutes && (error || props.id == null)
        ? "This content is currently unavailable."
        : "Loading…";
      return (
        <>
          <main className="container-lg text-center py-5">
            <p role="status">{message}</p>
          </main>
          <Footer />
        </>
      );
    }
  }

  function className() {
    let result = "container-lg";
    if (tileCollection.cssClass) {
      result = `container-lg ${tileCollection.cssClass}`;
    }
    return result;
  }

  const tiles = tileCollection.tiles.map((t, i) => (
    <Tile key={i} t={t} />
  ));

  function rowClassName() {
    let result;
    if (tileCollection.tiles.length === 3 || tileCollection.tiles.length > 4) {
      result = "row row-cols-1 row-cols-md-3";
    } else {
      result = "row row-cols-1 row-cols-md-2";
    }
    return result;
  }

  return (
    <>
      <main id="tile-collection" className={className()}>
        <h1 className="text-center page-title mb-3">{tileCollection.title}</h1>
        <div className="container-lg">
          <div className={rowClassName()}>{tiles}</div>
        </div>
      </main>
      <Footer />
    </>
  );
}

TileCollection.propTypes = {
  token: PropTypes.string,
  id: PropTypes.number,
  authenticated: PropTypes.bool,
  member: PropTypes.object,
  waitingForMember: PropTypes.bool,
  waitingForRoutes: PropTypes.bool,
  protectedBatchingFoundations: PropTypes.bool,
}
